import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
	gtmId: 'GTM-TSCWK8V'
}

TagManager.initialize(tagManagerArgs)
ReactDOM.render(
	<BrowserRouter>
		<Switch>
			<Route path={'/'} component={App}/>
			<Route component={App}/>}/>
		</Switch>
	</BrowserRouter>,
document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();


